module.exports = __webpack_public_path__ + "static/media/astro_energy.d0d2e3ff.png";